import { render } from "./ConnectionDetail.vue?vue&type=template&id=0c403222&scoped=true"
import script from "./ConnectionDetail.vue?vue&type=script&lang=js"
export * from "./ConnectionDetail.vue?vue&type=script&lang=js"

import "./ConnectionDetail.vue?vue&type=style&index=0&id=0c403222&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/82161804/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c403222"]])

export default __exports__